import { DialogWindow } from "./DialogWindow";
import { ButtonRequest } from "./ButtonRequest";
import { useState } from "react";
import { customColors } from "models/customColors";
import { Box, Stack, styled } from "@mui/material";
import { Confirmation } from "./Confirmation";

export const StepIndicator = styled(Box)`
  width: 85px;
  height: 5px;
  border-radius: 15px;
  background: ${customColors.lightGrayText};

  @media screen and (orientation: portrait) and (max-device-width: 1024px) {
    width: 40px;
  }
`;

export const StepIndicatorActive = styled(StepIndicator)`
  background-color: ${customColors.mainColor};
`;

export const steps = {
  SELECT_PROVIDER: 1,
  SELECT_RECIPIENT: 2,
};

export const NewButtonDialog = ({
  handleClose,
  showWarning,
  setError,
  originator,
  reloadButtons,
  providers,
  addNewProvider,
}) => {
  const [confirmation, setConfirmation] = useState(null);
  const [step, setStep] = useState(steps.SELECT_PROVIDER);
  const [isDataChanged, setIsDataChanged] = useState(false);

  const confirmedClose = () => {
    if (isDataChanged) {
      setConfirmation({
        title: "You have unsaved changes",
        message: "Are you sure you want to close this dialog?",
        proceedFn: () => handleClose(),
        cancelFn: () => setConfirmation(null),
      });
      return;
    }
    handleClose();
  };

  return (
    <DialogWindow
      title={
        <div className="flex flex-col items-center gap-1">
          <div className="font-bold">Add new button</div>
          <Stack direction={"row"} gap={1} mt={1.6} mb={1}>
            <StepIndicatorActive />
            {step === steps.SELECT_PROVIDER ? (
              <StepIndicator />
            ) : (
              <StepIndicatorActive />
            )}
          </Stack>
        </div>
      }
      content={
        <>
          <ButtonRequest
            showWarning={showWarning}
            setError={setError}
            originator={originator}
            handleClose={handleClose}
            reloadButtons={reloadButtons}
            providers={providers}
            step={step}
            setStep={setStep}
            setIsDataChanged={setIsDataChanged}
            addNewProvider={addNewProvider}
          />
          {confirmation && <Confirmation {...confirmation} />}
        </>
      }
      handleClose={confirmedClose}
      withCloseButton
    />
  );
};
